const en = {
  backToOrders: '← Back to Orders',
  title: 'Order Parts Report',
  print: '🖨️ Print',
  totalItems: 'Total Items',
  totalOrdered: 'Total Ordered',
  delivered: 'Delivered',
  backorder: 'Backorder',
  suppliers: 'Suppliers',
  tabAllItems: 'All Order Items ({{count}})',
  tabPartsSummary: 'Parts Summary ({{count}})',
  tabBackorder: 'Backorder',
  filterByStatus: 'Filter by Status (select multiple)',
  filterBySupplier: 'Filter by Supplier (select multiple)',
  activeFilters: 'Active filters:',
  statusLabel: 'Status: {{statuses}}',
  suppliersLabel: '| Suppliers: {{suppliers}}',
  clearAllFilters: 'Clear All Filters',
  noItems: 'No Items',
  noItemsMatchFilters: 'No items match your filters',
  noOrderItemsFound: 'No order items found',
  noParts: 'No Parts',
  noPartsMatchFilters: 'No parts match your filters',
  noPartsFound: 'No parts found',
  noBackorders: 'No Backorders',
  noBackordersMatchFilters: 'No backorders match your filters',
  allItemsDelivered: 'All items delivered',
  colOrder: 'Order',
  colDate: 'Date',
  colPart: 'Part',
  colSku: 'SKU',
  colSupplier: 'Supplier',
  colOrdered: 'Ordered',
  colDelivered: 'Delivered',
  colBackorder: 'Backorder',
  colStock: 'Stock',
  colItemStatus: 'Item Status',
  colOrderStatus: 'Order Status',
  colStatus: 'Status',
  colBy: 'By',
  colNotes: 'Notes',
  colTotalOrdered: 'Total Ordered',
  colOrders: 'Orders',
  totals: 'Totals:',
  statusPending: 'Pending',
  statusPartial: 'Partial',
  statusDelivered: 'Delivered',
  statusCancelled: 'Cancelled',
  statusNla: 'NLA',
  statusClosed: 'Closed',
};

const de = {
  backToOrders: '← Zurück zu Bestellungen',
  title: 'Bestellteile-Bericht',
  print: '🖨️ Drucken',
  totalItems: 'Positionen gesamt',
  totalOrdered: 'Bestellt gesamt',
  delivered: 'Geliefert',
  backorder: 'Rückstand',
  suppliers: 'Lieferanten',
  tabAllItems: 'Alle Bestellpositionen ({{count}})',
  tabPartsSummary: 'Teileübersicht ({{count}})',
  tabBackorder: 'Rückstand',
  filterByStatus: 'Nach Status filtern (Mehrfachauswahl)',
  filterBySupplier: 'Nach Lieferant filtern (Mehrfachauswahl)',
  activeFilters: 'Aktive Filter:',
  statusLabel: 'Status: {{statuses}}',
  suppliersLabel: '| Lieferanten: {{suppliers}}',
  clearAllFilters: 'Alle Filter zurücksetzen',
  noItems: 'Keine Positionen',
  noItemsMatchFilters: 'Keine Positionen entsprechen Ihren Filtern',
  noOrderItemsFound: 'Keine Bestellpositionen gefunden',
  noParts: 'Keine Teile',
  noPartsMatchFilters: 'Keine Teile entsprechen Ihren Filtern',
  noPartsFound: 'Keine Teile gefunden',
  noBackorders: 'Keine Rückstände',
  noBackordersMatchFilters: 'Keine Rückstände entsprechen Ihren Filtern',
  allItemsDelivered: 'Alle Positionen geliefert',
  colOrder: 'Bestellung',
  colDate: 'Datum',
  colPart: 'Teil',
  colSku: 'SKU',
  colSupplier: 'Lieferant',
  colOrdered: 'Bestellt',
  colDelivered: 'Geliefert',
  colBackorder: 'Rückstand',
  colStock: 'Bestand',
  colItemStatus: 'Positionsstatus',
  colOrderStatus: 'Bestellstatus',
  colStatus: 'Status',
  colBy: 'Von',
  colNotes: 'Notizen',
  colTotalOrdered: 'Bestellt gesamt',
  colOrders: 'Bestellungen',
  totals: 'Summe:',
  statusPending: 'Ausstehend',
  statusPartial: 'Teilweise',
  statusDelivered: 'Geliefert',
  statusCancelled: 'Storniert',
  statusNla: 'NLA',
  statusClosed: 'Geschlossen',
};

const orderPartsReport = { en, de };
export default orderPartsReport;
